module.exports = __webpack_public_path__ + "img/lingpiao.4d8f3c02.png";